import { redirect } from 'react-router-dom'

import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'
import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const investingJourneyRoutes = [
  {
    id: 'round-ups-onboarding',
    trackingName: 'Round Ups Onboarding',
    path: 'dl/view/investing/round_ups_onboarding',
    lazy: async () => ({
      Component: (await import('../components/JourneyRoundUpsOnboarding')).JourneyRoundUpsOnboarding,
      props: { isEditing: false },
    }),
  },
  {
    id: 'round-ups',
    trackingName: 'Round Ups',
    path: 'dl/view/investing/round_ups',
    loader: async () => {
      throw redirect(`/dl/flow/${FlowType.PIGGYBANK_SAVINGS_ROUND_UP}`)
    },
  },
] as const satisfies JourneyRoute[]
